/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditSupportBulkUploadBcrFilesMutationRequest, AuditSupportBulkUploadBcrFilesMutationResponse, AuditSupportBulkUploadBcrFiles401, AuditSupportBulkUploadBcrFiles403 } from "../models/AuditSupportBulkUploadBcrFiles";
import { buildFormData } from "../.kubb/config";

export function getAuditSupportBulkUploadBcrFilesUrl() {
  const res = { method: 'POST', url: `/audit-support/v1/bcr-files/bulk-upload` as const }
  return res
}

/**
 * @description Upload multiple files for processing and storage. Files are processed sequentially.
 * @summary Bulk upload BCR files
 * {@link /audit-support/v1/bcr-files/bulk-upload}
 */
export async function auditSupportBulkUploadBcrFiles(data: AuditSupportBulkUploadBcrFilesMutationRequest, config: Partial<RequestConfig<AuditSupportBulkUploadBcrFilesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const formData = buildFormData(requestData)
  const res = await request<AuditSupportBulkUploadBcrFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadBcrFiles401 | AuditSupportBulkUploadBcrFiles403>, AuditSupportBulkUploadBcrFilesMutationRequest>({ method : "POST", url : getAuditSupportBulkUploadBcrFilesUrl().url.toString(), data : formData as FormData, ... requestConfig })
  return res.data
}